
import React, { useEffect, useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import Rating from '@material-ui/lab/Rating';
import { makeStyles } from '@material-ui/core/styles';
import ButtonAction from '../../Buttons/ButtonAction';
import ModalShare from '../../Modal/ModalShare';
import FormDialog from '../Form/FormDialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Link as LinkScroll } from 'react-scroll';
import { isBrowser, isMobile, isTablet } from 'react-device-detect';

import './CardGeneralData.scss';

const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const useStyles = makeStyles({
  iconEmpty: {
    color: '#c1c1c1',
  },
  icon: {
    padding: '0 2px',
    fontSize: 24,
    '@media (max-width: 580px)': {
      fontSize: 16,
      padding: 0,
    },
  },
  
  languageItem: {
    padding: '0 10px !important',
    margin: '0 0 10px 0 !important',
    borderRight: '1px solid #7cd4d2',
    color: '#484848',
  },
});


const CardGeneralData = (props) => {
  const { generalData, client ,handleContactButton } = props
  const history = useHistory()

  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [openForm, setOpenForm] = useState(false);

  const handleShareModal = () => {
    if (onPreview) {
      setOpenModal(false)
    } else {
      if (generalData &&
        generalData.membership &&
        generalData.membership.type === 'Free') {
        setOpenModal(false)
      } else {
        setOpenModal(true)
      }
    }
  }

  const onPreview = useRouteMatch('/preview');
  const lawyerLogged =
    client && (client.role === 'lawyer' || client.role === 'lawFirm');

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const closeForm = () => {
    setOpenForm(false);
  };

  const stateTitle = (estado) => estado.toLowerCase().replace(/\b[a-z]/g, (letter) => {
    return letter.toUpperCase();
    });

  const tabletSize = useMediaQuery('(max-width: 768px');

  const is850px = useMediaQuery('(max-width: 850.98px');

  const link = `https://contactaabogado.com/${
    generalData.role === 'lawyer' ? 'abogado' : 'despacho'
  }/${generalData.uid}`;
  const clientLogged = client && client.role === 'cliente';

  const defaultAvatarClient =
    generalData && generalData.role === 'lawyer'
      ? generalData.genero === 'male'
        ? maleAvatar
        : femaleAvatar
      : lawFirmAvatar;
  


  useEffect(() => {
    window.previousLawFirmLocation = history.location.pathname
  }, [])
  

  const tituloNombre = (auth) => {
    switch (auth.gradeStudy) {
      case 'Licenciatura':
        return 'Lic.';
      case 'Maestría': {
        if (auth.genero == 'male') {
          return 'Mtro.';
        } else if (auth.genero == 'female') {
          return 'Mtra.';
        }
        return 'null';
      }
      case 'Especialidad':
        return 'Esp.';
      case 'Doctorado': {
        if (auth.genero == 'male') {
          return 'Dr.';
        } else if (auth.genero == 'female') {
          return 'Dra.';
        }
        return null;
      }

      default:
        return null;
    }
  };

  let qualification
  if (generalData) {
    qualification = generalData.analytics &&
      Number(generalData.analytics.opinion.qualification);
  }

  const membership = generalData && generalData.membership && generalData.membership.type;
  
  return (
    <>
      <section className="cardPerfil">
        <div className="cardPerfil_infoContainer">
          <div className="cardPerfil_infoContainer_sec1">
            <figure className="cardPerfil_infoContainer_fig">
              {generalData ? (
                generalData.imgProfile ? (
                  <img
                    className={generalData.role === 'lawyer' ? 'cardPerfil_infoContainer_fig_img1' : 'cardPerfil_infoContainer_fig_img2'}
                    src={generalData.imgProfile}
                    alt="imagen de perfil"
                  />
                ) : (
                  <img
                    src={defaultAvatarClient}
                    className='cardPerfil_infoContainer_fig_img3'
                    alt="imagen de perfil" />
                )
              ) : (
                <img
                  src={defaultAvatarClient}
                  className='cardPerfil_infoContainer_fig_img3'
                  alt="imagen de perfil"
                />
              )
              }
            </figure>

            {!isMobile &&
              <div className="cardPerfil_infoContainer_cali">
                {
                generalData ?
                  <p style={{ margin: 0 }}>{`${generalData.analytics !== undefined ? qualification : 0}/5`}</p> :
                  null
                }
                {
                generalData ?
                  <div className="cardPerfil_infoContainer_stars">
                    <Rating
                      defaultValue={generalData.analytics !== undefined ? generalData.analytics.opinion.qualification : 0}
                      precision={0.25}
                      classes={{ iconEmpty: classes.iconEmpty, icon: classes.icon }}
                      readOnly
                    />
                  </div> :
                  null
                }
              </div>
            }
          </div>

          {generalData && generalData.membership && generalData.membership.type !== 'Free' &&
          <div className="cardPerfil_infoContainer_sec2">
            {isMobile ? (
              <button
                className="cardPerfil_infoContainer_button"
                onClick={handleOpenForm}
                style={{cursor: onPreview? 'not-allowed': 'pointer', backgroundColor: onPreview? '#7cd4d2':'#35b9b6'}}
              >
                Contactar
              </button>
            ) : tabletSize ? (
              <button
                className="cardPerfil_infoContainer_button"
                onClick={handleOpenForm}
                style={{cursor: onPreview? 'not-allowed': 'pointer', backgroundColor: onPreview? '#7cd4d2':'#35b9b6'}}
              >
                Contactar
              </button>
            ) : (
              <LinkScroll
                to="contactForm"
                smooth={true}
                onClick={() => {
                  setTimeout(handleContactButton, 1000);
                }}
              >
                <button className="cardPerfil_infoContainer_button" style={{cursor: onPreview? 'not-allowed': 'pointer', backgroundColor: onPreview? '#7cd4d2':'#35b9b6'}}>
                  Contactar
                </button>
              </LinkScroll>
            )}
          </div>}

          <div className="cardPerfil_sec3">
            <div className="cardPerfil_nameContainer">
              
                {
                  generalData ?
                    (
                      <p className="cardPerfil_name">
                        {generalData && generalData.gradeStudy
                          ? (generalData.role == 'lawFirm' ? ('') : (tituloNombre(generalData)))
                          : ''}

                        {generalData && generalData.role ? 
                          generalData.role == 'lawFirm' ?
                            generalData.officeName :
                            generalData.lastName && !generalData.secondLastName ?
                            ` ${generalData.name ? generalData.name : ''} ${generalData.lastName ? generalData.lastName : ''}` :
                            ` ${generalData.name ? generalData.name : ''} ${generalData.firstLastName ? generalData.firstLastName : ''} ${generalData.secondLastName ? generalData.secondLastName : ''}`
                          : null}
                      </p>
                    ) :
                  null
                }
              <div className="cardPerfil_infoContainer_badgeAndShare">
                {isMobile &&
                  <div
                    className={
                      membership === 'Free' ?
                      "cardPerfil_infoContainer_compartir_disabled cardPerfil_infoContainer_compartir" :
                      "cardPerfil_infoContainer_compartir"
                    }
                  >
                    <button onClick={handleShareModal}>
                      <figure>
                        <img src="/img/profileClient/compartir.svg" alt="" />
                      </figure>
                      <p>compartir</p>
                    </button>
                  </div>
                }
              </div>
            </div>
            <div className="cardPerfil_infoContainer_location_flex">
              {isMobile ?
                <>
                  {
                    generalData ?
                    (
                      <div className="cardPerfil_infoContainer_cedulaContainer">
                        <p className="cardPerfil_infoContainer_cedula">
                          {generalData && generalData.cedula && `No. de cédula:`}
                        </p>
                        <p className="cardPerfil_infoContainer_cedulaNumber">
                          {generalData && generalData.cedula && `${generalData.cedula && generalData.cedula}`}
                        </p>
                      </div>
                    ) :
                    null
                  }
                </> :
                <>
                  {
                    generalData ?
                    (
                      <p className="cardPerfil_infoContainer_cedula">
                        {generalData && generalData.cedula && `No. de cédula: ${generalData.cedula && generalData.cedula}`}
                      </p>
                    ) :
                    null
                  }
                </>
              }
              
            </div>
            {isMobile &&
              <div className="cardPerfil_infoContainer_cali">
                {
                generalData ?
                  <p style={{ margin: 0 }}>{`${generalData.analytics !== undefined ? qualification : 0}/5`}</p> :
                  null
                }
                {
                generalData ?
                  <div className="cardPerfil_infoContainer_stars">
                    <Rating
                      defaultValue={generalData.analytics !== undefined ? generalData.analytics.opinion.qualification : 0}
                      precision={0.25}
                      classes={{ iconEmpty: classes.iconEmpty, icon: classes.icon }}
                      readOnly
                    />
                  </div> :
                  null
                }
              </div>
            }
          </div>
          <div className="cardPerfil_infoContainer_sec4">
            <div className="cardPerfil_infoContainer_espe">
              <div className='cardPerfil_infoContainer_firstContainer'>
                {generalData && generalData.membership && generalData.membership.type !== 'Free' &&
                <div className="cardPerfil_infoContainer_text">
                  <p style={{ marginBottom: 0 }}>Ubicación</p>
                  {generalData ?
                      (
                        <p>
                          {generalData.sede && generalData.sede.length > 0
                            ? `${generalData.sede[0].estado}, ${generalData.sede[0].municipio}`
                            : 'Sede no definida'}
                        </p>
                      ) : null
                  }
                  
                </div>}
                {generalData ?
                  (
                    <div className="cardPerfil_infoContainer_text2">
                      {generalData && generalData.expYears && (
                        <>
                          <p style={{ marginBottom: 0 }}>Años de Experiencia</p>
                          <p>{generalData.expYears}</p>
                        </>
                      )}
                    </div>
                  ) : null
                }
              </div>
              
              <div
                className="cardPerfil_infoContainer_text-flex"
                style={{
                  margin: '0 20px 24px 0',
                  justifyContent: 'space-between',
                  flexWrap: 'nowrap',
                  display: 'flex'
                }}
              >
                {
                  generalData && generalData.colegNumber ?
                  (
                    <div
                      className="cardPerfil_infoContainer_text extra"
                      style={{
                        margin: 0,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          width: 'inherit',
                        }}
                      >
                        Número de colegiado
                      </p>
                      <p>{generalData.colegNumber}</p>
                    </div>
                  ) :
                  null
                }

                {
                  generalData && generalData.gradeStudy ?
                  (
                    <div className="cardPerfil_infoContainer_text extra">
                      <p style={{margin: 0}}>Grado</p>
                      <p>{generalData.gradeStudy}</p>
                    </div>
                  ) :
                  null
                }
              </div>

              {generalData && generalData.languages ?
                (
                  <div
                    className="cardPerfil_infoContainer_text"
                    style={{
                      margin: '0 0 40px 0'
                    }}
                  >
                    <p
                      style={{
                        width: 254,
                        margin: '0 0 5px 0'
                      }}
                    >
                      Idiomas en que atiende
                    </p>
                    <div className="cardPerfil_infoContainer_languages">
                      {generalData.languages.map(item => <p className={classes.languageItem}>{item}</p>)}
                    </div>
                  </div>
                ) :
                null
              }

            </div>
          </div>
          <div 
            className="cardPerfil_infoContainer_border" 
            style={{ backgroundImage: 'linear-gradient(104deg, #9e852d 5%, #dfdfdf 29%, #9e852d 74%, #9e852d 96%)' }}
          />
          {!isMobile &&
            <div
              className={
                membership === 'Free' ?
                "cardPerfil_infoContainer_compartir_disabled cardPerfil_infoContainer_compartir" :
                "cardPerfil_infoContainer_compartir"
              }
            >
              <button onClick={handleShareModal}>
                <figure>
                  <img src="/img/profileClient/compartir.svg" alt="" />
                </figure>
                <p>compartir</p>
              </button>
            </div>
          }
        </div>
        
        {generalData && generalData.membership && generalData.membership.type !== 'Free' && 
        <div className="cardPerfil_contact">
          <ButtonAction
            variant="extra"
            style={{ width: 312, height: 40, fontSize: 16 }}
            onClick={
              isMobile
                ? handleOpenForm
                : (tabletSize
                ? handleOpenForm
                : handleContactButton)
            }
          >
            Contactar
          </ButtonAction>
        </div>}
      </section>

      <ModalShare
        open={openModal}
        link={link}
        isSocial={true}
        handleClose={handleClose}
      />

      {
        (isMobile || (isBrowser && tabletSize)) && generalData ?
        (
          <FormDialog
            user={generalData}
            contact={generalData && generalData.contacto}
            openForm={openForm}
            handleClose={closeForm}
          />
        ) :
        null
      }
    </>
  );
};

export default CardGeneralData;
